// Israeli business / personal id numbers (ת״ז, עוסק מורשה/פטור, ח״פ), shared by
// the staff profile, the box/P&L-unit settings and the invoice check.
/** Strip everything but digits and left-pad to 9 — Israeli ת״ז / עוסק / ח״פ
 *  numbers are 9 digits and short ones are written without their leading zeros.
 *  Returns null for anything that can't be one. */
export function normalizeBusinessId(v) {
    const digits = (v ?? '').replace(/\D/g, '');
    if (!digits || digits.length > 9)
        return null;
    return digits.padStart(9, '0');
}
/** The ת״ז check digit, which עוסק מורשה/פטור numbers and ח״פ (companies, 51…;
 *  עמותות, 58…) all share: alternate ×1/×2, fold two-digit products, sum % 10 = 0. */
export function isValidBusinessId(v) {
    const id = normalizeBusinessId(v);
    if (!id || /^0+$/.test(id))
        return false;
    let sum = 0;
    for (let i = 0; i < 9; i++) {
        let d = Number(id[i]) * ((i % 2) + 1);
        if (d > 9)
            d -= 9;
        sum += d;
    }
    return sum % 10 === 0;
}
//# sourceMappingURL=business-id.js.map